/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/* jshint ignore:start */
function detectTouchSupport() {
  var msGesture;
  var touchSupport;

  (msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture),
    (touchSupport =
      "ontouchstart" in window || msGesture || (window.DocumentTouch && document instanceof DocumentTouch));
  if (touchSupport) {
    $("body").addClass("touch");
  } else {
    $("body").addClass("no-touch");
  }
}
/* jshint ignore:end */

detectTouchSupport();

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

Fancybox.bind(".fancybox-storyboard", {
  closeButton: "inside",
  infinite: true,
  on: {
    done: (fancybox, slide) => {
      //afterFancyboxLoad();
    }
  },
  // Use template to force counter to display on stroyboards
  template: {
    main: '<div class="fancybox__container testing" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"> <div class="fancybox__backdrop"></div> </div>'
  }
});

/*  ==========================================================================
  GENERAL - Footer Images
========================================================================== */
const footerImagesInit = function () {
  var footerImages = [];
  let images = document.querySelectorAll(".profile-img");

  if (!images) {
    return;
  }

  images.forEach((image, i) => {
    footerImages.push("url(" + image.getAttribute("data-src") + ")");
  });

  let icons = document.querySelectorAll(".team-icon");
  icons.forEach((icon, i) => {
    icon.style.backgroundImage = footerImages[i];
  });
}; // footerImagesInit();
footerImagesInit();

/*  ==========================================================================
    GENERAL - Full Height Home Header
  ========================================================================== */
function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty("--ch", window.innerHeight * 0.01 + "px");
}
window.addEventListener("resize", appHeight);
appHeight();

/*  ==========================================================================
    GENERAL - Footer Animation
  ========================================================================== */

const footetBtn = document.querySelector(".btn--footer");
const footerLeader = document.querySelector(".sitefooter__cta__leader");

const footetBtnInit = function (footetBtn) {
  if (!footetBtn) {
    return;
  }

  footetBtn.addEventListener("mouseover", function () {
    footerLeader.classList.add("active");
  });

  footetBtn.addEventListener("mouseleave", function () {
    footerLeader.classList.remove("active");
  });
}; // footetBtnInit();
footetBtnInit(footetBtn);

/*  ==========================================================================
    GENERAL - Filter
  ========================================================================== */

const filterButton = document.querySelector(".filter__button");

const filterDropdownInit = function (filterButton) {
  if (!filterButton) {
    return;
  }

  filterButton.addEventListener("click", function () {
    filterButton.classList.toggle("active");
  });
}; // filterDropdownInit();
filterDropdownInit(filterButton);

$(document).ready(function () {
  $(".wp-video-shortcode").each(function (i) {
    $(this).attr("src", $(this).find("a").attr("href"));
  });
});

/*  ==========================================================================
    GENERAL - Capabailities List Dropdown
  ========================================================================== */
/* jshint ignore:start */

var acc = document.getElementsByClassName("has-children");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
/* jshint ignore:end */

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

  const loadmoreBtn = document.querySelector(".paging__loadmore");
  const loadmoreContainer = document.querySelector(".loadmore-container");

  const loadmoreLoadPostsMultiplePages = function (pages) {

    if(pages && pages > 1){

      //Stopping default scroll back to previous position
      history.scrollRestoration = 'manual';

      const currentPage = new URL(window.location);
  
      //Creating an array on page numbers to map it
      var list = [];
      for (var i = 1; i < pages; i++) {
        list.push(i);
      }
  
      // Initialising the array of posts pages
      var postsHTML = [];

      const button = loadmoreBtn;
      const buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

      // Array of ajax calls
      var allAJAX = list.map(function(page){
          const data = {
            action: "loadmore",
            query: php_variables.posts, // that's how we get params from wp_localize_script() function
            page: page
          };
          //Updating the url to mtch the page number
          currentPage.searchParams.set('pagenum', page);
          return $.ajax({
            url: php_variables.ajax_url, // AJAX handler
            data: data,
            type: "POST",
            success: function (data) {
              postsHTML[page] = data;
            }
          });
      });

      // Waiting for all the ajax calls to be finished before proceeding
      Promise.all(allAJAX).then(function() {
        // Update current page variable
        php_variables.current_page = pages;

        button.textContent = buttonText; // set back to previous button text

        // Adding the new tiles to the dom
        list.map(page => {
          if(postsHTML[page]){
              loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
            }
        });

        // Updating the href for the loadmore button
        const nextPage = new URL(window.location);
        nextPage.searchParams.set('pagenum', parseInt(pages) + 1);
        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
          
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        // Scrolling the page to the last known position
        if(localStorage.getItem("scrollPosition")) {
          window.scroll({
            top: parseInt(localStorage.getItem("scrollPosition"), 10),
            behavior: "instant"
          });
        }
        
      });
    }
  };
  
  const loadmoreLoadPosts = function (e) {

    e.preventDefault(); // Preventing the a tag from redirecting to the page
    
    const button = this;
    const data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    let buttonText; // create variable to store button text
  
    // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        buttonText = button.textContent; // store current button text
        button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.textContent = buttonText; // set back to previous button text 
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
          
          php_variables.current_page++;

          // Only push state to set the last page number or if there is more pages to load
          const currentPage = new URL(window.location);
          
          if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
            currentPage.searchParams.set('pagenum', php_variables.current_page);
            history.pushState({}, "", currentPage);
          }

          //Updating the loadmore link
          const nextPage = new URL(window.location);
          nextPage.searchParams.set('pagenum', parseInt(php_variables.current_page) + 1);

          button.href = nextPage;
  
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.style.display = "none";
          }
          // Re-init links to make sure linklines on newly loaded content still work
          linksInit();
          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones
          // Re-init effects
          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);
          
        } else {
          button.style.display = "none"; // if no data, remove the button as well
        }
      }
    });
  }; // loadmoreLoadPosts();
  
  const loadmoreInit = function () {
    if (!loadmoreBtn) {
      return;
    }
    /** When adding fitering you will need to move this part into the filtering call */
    // Checking if the page paramenter is set
    const currentPage = new URL(window.location);
    let currentPageNum = currentPage.searchParams.get('pagenum');

    //If there is more than one page to load
    if(currentPageNum && currentPageNum > 1){    
      currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
      loadmoreLoadPostsMultiplePages(currentPageNum);
    }
    /** -end- */

    // Saving the scroll position before unload
    window.addEventListener("unload", function(e) {
      var scrollPosition = window.pageYOffset;
      localStorage.setItem("scrollPosition", scrollPosition);
    });
    
    loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
  }; // loadmoreInit();
  
  loadmoreInit();
/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

const pinnedLists = document.querySelectorAll(".pinned-list");

const pinnedListsInit = function (pinnedLists) {
  if (!pinnedLists) {
    return;
  }

  pinnedLists.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
          $(".pinned-img__img").removeClass("active");
          $("." + val.dataset.swap).addClass("active");
        } else {
          val.classList.remove("effect--ready");
          $(".pinned-img__img").removeClass("active");
          $("." + val.dataset.swap).addClass("active");
        }
      },
      offset: "15%"
    });
  });
}; // pinnedListsInit();
pinnedListsInit(pinnedLists);

/*  ==========================================================================
    Page Header Type Effects
    ========================================================================== */

const pageHeading = document.querySelector(".pageheader__heading--typed");

const pageHeadingInit = function (pagheaders) {
  if (!pagheaders) {
    return;
  }

  new TypeIt("#pageheader__heading--typed", {
    speed: 50,
    startDelay: 900,
    cursorChar: "|",
    beforeString: () => {
      pageHeading.classList.add("is-typing");
    },
    afterComplete: function (instance) {
      setTimeout(function () {
        pageHeading.classList.add("pageheader__heading--complete");
      }, 1000);

      setTimeout(function () {
        pageHeading.classList.add("pageheader__heading--fade-out");
      }, 3000);
    }
  }).go();
};
pageHeadingInit(pageHeading);

/*  ==========================================================================
    Homepage animation
    ========================================================================== */

const pageHeadingSlider = document.querySelector(".pageheader__heading--slider");

const pageHeadingSliderInit = function (pageHeadingSlider) {
  if (!pageHeadingSlider) {
    return;
  }

  let interval;

  const auto = () => {
    if (interval) {
      clearInterval(interval);
    }
    interval = setInterval(() => {
      const next = jQuery(".pageheader__heading--slider .pageheader__word.active").next(".pageheader__word");
      if (next.length !== 0) {
        jQuery(".pageheader__heading--slider .pageheader__word").removeClass("active");
        next.addClass("active");
      } else {
        jQuery(".pageheader__heading--slider .pageheader__word").removeClass("active");
        jQuery(".pageheader__heading--slider .pageheader__word:first-child").addClass("active");
      }
    }, 2500);
  };
  auto();
};
pageHeadingSliderInit(pageHeadingSlider);

/*  ==========================================================================
    Large Accordion
  ========================================================================== */
var acc = document.getElementsByClassName("large-accordion__heading");
var i;
/* jshint ignore:start */

for (i = 0; i < acc.length; i++) {
  if (!isTouchDevice) {
    acc[i].addEventListener("mouseout", function () {
      if (this.classList.contains("active") == false) {
        this.classList.remove("hover");
        this.parentElement.classList.remove("hover");
        var panel = this.nextElementSibling;
        panel.style.maxHeight = "0px";

        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);
      }
    });

    acc[i].addEventListener("mouseover", function () {
      if (this.classList.contains("active") == false) {
        this.classList.add("hover");
        this.parentElement.classList.add("hover");
        var panel = this.nextElementSibling;
        panel.style.maxHeight = "3.25em";
      }
    });

    acc[i].addEventListener("click", function () {
      this.classList.remove("hover");
      this.classList.toggle("active");
      this.parentElement.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight == "3.25em") {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } else if (panel.style.maxHeight > "100px") {
        panel.style.maxHeight = "0px";
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  } else {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }

      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  }
}
/* jshint ignore:end */

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel:not(.case-studies)");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        setTimeout(function () {
          lazyLoadInstance.update();
          Waypoint.refreshAll();
        }, 500);
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
			Case Studies Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const caseStudiesCarousels = document.querySelectorAll(".row--carousel .case-studies");

const caseStudiesCarouselsInit = function (caseStudiesCarousels) {
  if (caseStudiesCarousels.length <= 0) {
    return;
  }

  caseStudiesCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplaytimeout ? elem.dataset.autoplaytimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      onInitialized: function () {
        setTimeout(function () {
          lazyLoadInstance.update();
          Waypoint.refreshAll();
        }, 500);
      }
    });

    $(elem).on("changed.owl.carousel", function (event) {
      if (autoplay !== false) {
        $(elem).trigger("stop.owl.autoplay");
        $(".counter").addClass("restart");

        setTimeout(function () {
          $(elem).trigger("play.owl.autoplay");
          $(".counter").removeClass("restart");
        }, 500);
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      if (autoplay !== false) {
        setTimeout(function () {
          $(elem).trigger("stop.owl.autoplay");
          $(".counter").addClass("restart");

          $(elem).trigger("play.owl.autoplay");
          $(".counter").removeClass("restart");
        }, 500);
      }
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // caseStudiesCarouselsInit();
caseStudiesCarouselsInit(caseStudiesCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - Desktop Nav
	========================================================================== */
const desktopDropdownLinks = document.querySelectorAll(".sitenav--center .inlinenavlist .sitenav__item--hasdropdown");
const menuOverlayDesktop = document.querySelector(".menu-overlay--desktop");

const desknavlinksInit = function () {
  if (!desktopDropdownLinks) {
    return;
  }

  desktopDropdownLinks.forEach(function (desktopDropdownLink) {
    desktopDropdownLink.addEventListener("mouseenter", function (e) {
      menuOverlayDesktop.classList.add("active");
    });

    desktopDropdownLink.addEventListener("mouseleave", function (e) {
      menuOverlayDesktop.classList.remove("active");
    });
  });
}; // desknavlinksInit();
desknavlinksInit();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */
const mobNav = document.querySelector(".mobnav");
const mobToggle = document.querySelector(".mobnav__toggle");
const mobList = document.querySelector(".mobnav__list");
const mainNav = document.querySelector(".siteheader");
const menuOverlayMobile = document.querySelector(".menu-overlay--mobile");

mobToggle.addEventListener("click", () => {
  mobNav.classList.toggle("active");
  menuOverlayMobile.classList.toggle("active");
});

// Getting the height of the mobile navigation.
window.addEventListener("load", onLoadNav);

function onLoadNav(e) {
  //Calling heightNav function on load.
  heightNav();
  window.addEventListener("resize", heightNav); //Get the nav height when the user resizes the window
}

function heightNav(e) {
  document.documentElement.style.setProperty("--y", mobList.clientHeight + "px");
}
